import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import data from "./data.json";
import logo from "./assets/logo.png";
import "./CardPage.css";

const CardPage = () => {
  const { slug } = useParams();
  
  // Chiamate ai React Hooks incondizionatamente
  const [isZoomed, setIsZoomed] = useState(false);
  const [qrBg, setQrBg] = useState("transparent");

  // Ora cerca il record
  const person = data.find((p) => p.slug.toLowerCase() === slug.toLowerCase());
  if (!person) return <div>Biglietto non trovato</div>;

  const baseUrl = "https://biglietti.radioradio.it";
  const qrUrl = `${baseUrl}/${person.slug}`;

  // Toggle per cambiare lo sfondo del QR code (singolo click)
  const handleToggleQRBg = () => {
    setQrBg((prev) => (prev === "transparent" ? "white" : "transparent"));
  };

  // Attiva lo zoom con singolo click sul QR code
  const handleQRClick = () => {
    setIsZoomed(true);
  };

  // Chiudi overlay zoom al click sull'overlay
  const handleCloseZoom = () => {
    setIsZoomed(false);
  };

  const handleSaveContact = () => {
    const vcard = `BEGIN:VCARD
VERSION:3.0
N:${person.surname};${person.name}
FN:${person.name} ${person.surname}
TEL;TYPE=CELL:${person.phone}
EMAIL;TYPE=INTERNET:${person.email}
TITLE:${person.role}
END:VCARD`;
    const blob = new Blob([vcard], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${person.slug}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="card-page">
      <header className="header">
        <img src={logo} alt="Logo" className="logo" />
      </header>
      <main className="content">
        <h1 className="name">
          {person.name} {person.surname}
        </h1>
        <h2 className="role">{person.role}</h2>
        
        
        <div className="qr-section" onClick={handleQRClick}>
          <QRCodeCanvas
            value={qrUrl}
            size={150}
            bgColor={ "#ffffff"}
            fgColor="#000000"
            className="qr-qr"
          />
        </div>
        
        <button className="save-btn" onClick={handleSaveContact}>
          SALVA CONTATTO
        </button>
      </main>
      {isZoomed && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <div className="zoom-container">
            <QRCodeCanvas
              value={qrUrl}
              size={300}
              bgColor={"#ffffff"}
              fgColor="#000000"
              className="qr-zoom"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CardPage;
